import React from 'react';
import Navigation from "../../components/navigation";
import {Stack} from "@mui/material";
import {Outlet} from "react-router";
import {useSession} from "../../firebase/UserProvider";
import {HELP_NAV_LINK} from "../../constants/helpNavLink";
import {COLLECTION_NAV_LINK} from "../../constants/collectionNavLink";
import {canAccessCollectionTab} from "../../features/collection/collectionTaskPayload";

const AppAnalyst = () => {
    const {role, roles} = useSession();
    const canViewAnalytics = Array.isArray(roles) && (roles.includes('admin') || roles.includes('manager'));
    const showCollectionNav = canAccessCollectionTab(role, roles);

    const navLinks = [
        ...(canViewAnalytics ? [{destination: "analytics", label: "Ops Insights"}] : []),
        {destination: "workflow", label: "Workflow"},
        {destination: "/icr", label: "Requirements", activePrefixes: ["/icr"]},
        ...(showCollectionNav ? [COLLECTION_NAV_LINK] : []),
        {destination: "products", label: "Products"},
        {destination: "charts", label: "Charts"},
        {destination: "experts", label: "Experts"},
        {destination: "feed", label: "Feeds"},
        {destination: "kb", label: "KB"},
        HELP_NAV_LINK,
    ]

    return (
        <Stack height={'100vh'} overflow={'hidden'}>
            <Navigation navLinks={navLinks}/>
            <Stack flex={1} overflow={'auto'}>
                <Outlet/>
            </Stack>
        </Stack>
    );
};

export default AppAnalyst;